import { en_us } from "@/locales/en_us";
import { es_us } from "@/locales/es_us";
import { pt_br } from "@/locales/pt_br";

export const messages = {
  'en-US': en_us,
  'pt-BR': pt_br,
  'es-US': es_us,
};

export function selectLocation(country: string): string {
  if (country == 'usa') {
    return 'en-US';
  } else if (country == 'br') {
    return 'pt-BR';
  } else if (country == 'es') {
    return 'es-US';
  } else {
    return 'pt-BR';
  }
}